import React, { useState } from "react";
import { Formik, Form } from "formik";

import { setInitialValues, formSchema } from "./Helpers/formConfig";
import { countryData } from "./Helpers/countryData";
import { db, analytics } from "./Helpers/firebase";

import { FieldRow, StyleInput, Button } from "./FormComponents";

const initialValues = setInitialValues();

const MainForm = ({ setFormSuccess }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={formSchema}
      onSubmit={values => {
        setIsSubmitting(true);

        db.collection("emails")
          .doc(values.email.trim())
          .set(
            {
              email: values.email.trim(),
              country: values.country,
              timestamp: new Date().toString()
            },
            { merge: true }
          )
          .then(() => {
            setFormSuccess(true);
            setIsSubmitting(false);
            analytics.logEvent("form_submit", {
              country: values.country
            });
          })
          .catch(err => {
            setIsSubmitting(false);
            setFormSuccess(false);
            analytics.logEvent("form_error", {
              message: err.toString()
            });
          });
      }}
    >
      {({ errors, touched }) => (
        <Form>
          <FieldRow>
            <StyleInput
              errors={errors}
              label="Email Address"
              name="email"
              placeholder="name@example.com"
              required={true}
              touched={touched}
              type="email"
            />

            <StyleInput
              component="select"
              errors={errors}
              label="Country"
              name="country"
              required={true}
              touched={touched}
              type="select"
            >
              <option value="" defaultValue disabled>
                Select your country
              </option>
              {countryData.map((country, i) => (
                <option
                  value={country.name}
                  key={`country-${i}`}
                  data-country-code={country.code}
                >
                  {country.name}
                </option>
              ))}
            </StyleInput>
            <Button type="submit" disabled={isSubmitting}>
              Submit
            </Button>
          </FieldRow>
        </Form>
      )}
    </Formik>
  );
};

export default MainForm;
